import scubeContext from './scubeContext';
import {AES, enc} from 'crypto-js';

export type scubeResponseActionType = {
  status: string;
  errors?: any[];
  warnings?: any[];
  fieldErrors?: any[];
  fieldWarnings?: any[];
  ok: boolean;

  sourceIds?: string[];
}

export class scubeResponseAction {
  status: string;
  errors?: any[];
  warnings?: any[];
  fieldErrors?: any[];
  fieldWarnings?: any[];
  ok: boolean = false;
  sourceIds?: string[];
  constructor(status: string, ok: boolean = false) {
    this.status = status;
    this.ok = ok;
  }
}

export class scubeResponse<T> extends scubeResponseAction {
  data?: T;
  hasData: boolean = false;

  constructor(data?: T, ok: boolean = false, status = '200') {
    super(status);
    this.data = data;
    this.hasData = data !== undefined;
  }
}

export function restGetFetch<T>(curUrl: string, signal?: AbortSignal): Promise<scubeResponse<T>> {
  return new Promise<scubeResponse<T>>((resolve, reject) => {
    fetch(curUrl, {
      signal: signal,
      headers: { Authorization: 'Bearer ' + scubeContext.t2atoken },
    })
      .then((response) => {
        //no content response
        if (response.status === 204) {
          let result = new scubeResponse<T>(undefined, true);
          resolve(result);
          return undefined;
        }

        if (!response.ok) {
          //if (response.status === 204 || response.status === 101 || response.status === 205 || response.status === 304)
          //101, 204, 205, or 304
          //console.debug("[API] GET: Not Ok.", response.status);
          let resData: T = {} as T;
          let result = new scubeResponse(resData, false);
          resolve(result);
          return undefined;
        }
        return response.json();
      })
      .then((json) => {
        if (json !== undefined) {
          //decrypt data only if needed
          if (json.isEncrypted) {
            let r2 = enc.Utf8.stringify(AES.decrypt(json.content, 'jdjdkstgggshdncbvgdjslsk'));
            json = JSON.parse(r2);
          }

          if(json.status === 'FeatureConditionNotMatched')
          {
            console.warn('FeatureConditionNotMatched');
          }

          if (json.status) {
            resolve(json);
          } else {
            let resData: T = json as T;
            let result = new scubeResponse(resData, true);
            //console.debug("[API] GET: Result", result);
            resolve(result);
          }
        } else {
          //console.debug("[API] GET: Received empty result.");
        }
      })
      .catch((error) => {
        console.error('[API] GET:', error);
        //this.handleError(error);
        //resolve error
      });
  });
}

export function restCreateFetch<T>(curUrl: string, postData: T, signal?: AbortSignal): Promise<scubeResponseAction> {
  return new Promise<scubeResponseAction>((resolve, reject) => {
    fetch(curUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      body: JSON.stringify(postData),
      signal: signal,
    })
      .then(async (response) => {
        if (!response.ok) {
          const body = await response.json();
          //this.handleResponseError(response);
          //resolve error
          console.debug('[API] POST: Not Ok', body);
          reject(body);
        }
        //console.debug("[API] POST: Response Ok.");
        resolve(new scubeResponseAction('Ok', response.ok));
        //return;// response.json();
      })
      // 	.then(json => {
      // 	  console.debug("[API] POST: Received some items.");
      // 	//   let resData: T = json as T;
      // 	//   let result = new scubeResponse(resData);
      // 	  console.debug("[API] POST: Received items", result);
      // 	  //resolve(result);
      //   })
      .catch((error) => {
        console.error('[API] POST:', error);
        //this.handleError(error);
        //resolve error
      });
  });
}

export function restDeleteFetch(curUrl: string, signal?: AbortSignal): Promise<scubeResponseAction> {
  return new Promise<scubeResponseAction>((resolve, reject) => {
    fetch(curUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      signal: signal,
    })
      .then(async (response) => {
        const contentLength = response.headers.get('Content-Length');
        if (response.ok && contentLength == '0') {
          resolve(new scubeResponseAction('Ok', true));
          return undefined;
        }

        if (!response.ok) {
          const body = await response.json();
          console.debug('[API] DELETE: Not Ok', body);
          reject(body);
        }
        return response.json();
        //console.debug("[API] DELETE: Response Ok.");
        //resolve(new scubeResponseAction('Ok', response.ok));
      })
      .then((json) => {
        if (json && json.status) {
          resolve(json);
        } else {
          // let resData: TResponse = json as TResponse;
          // let result = new scubeResponse(resData, true);
          // resolve(result);
          resolve(new scubeResponseAction('Ok', true));
        }
      })
      .catch((error) => {
        console.error('[API] DELETE:', error);
      });
  });
}

export function restDeleteFetchBack<TResponse>(
  curUrl: string,
  signal?: AbortSignal
): Promise<scubeResponse<TResponse>> {
  return new Promise<scubeResponse<TResponse>>((resolve, reject) => {
    fetch(curUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      signal: signal,
    })
      .then(async (response) => {
        const contentLength = response.headers.get('Content-Length');

        if (response.ok && contentLength == '0') {
          let result = new scubeResponse<TResponse>(undefined, true);
          resolve(result);
          return undefined;
        }


        if (!response.ok) {
          const body = await response.json();
          console.debug('[API] Delete: Not Ok', body);
          reject(body);
        }
        return response.json();
      })
      .then((json) => {
        if (json && json.status) {
          resolve(json);
        } else {
          let resData: TResponse = json as TResponse;
          let result = new scubeResponse(resData, true);
          resolve(result);
        }
      })
      .catch((error) => {
        console.error('[API] Delete:', error);
      });
  });
}

export function restPostFetch<TRequestion, TResponse>(
  curUrl: string,
  postData: TRequestion,
  signal?: AbortSignal
): Promise<scubeResponse<TResponse>> {
  return new Promise<scubeResponse<TResponse>>((resolve, reject) => {
    fetch(curUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      body: JSON.stringify(postData),
      signal: signal,
    })
      .then(async (response) => {
        const contentLength = response.headers.get('Content-Length');

        if (response.ok && contentLength == '0') {
          let result = new scubeResponse<TResponse>(undefined, true);
          resolve(result);
          return undefined;
        }

        if (!response.ok) {
          const body = await response.json();
          console.debug('[API] POST: Not Ok', body);
          reject(body);
        }
        return response.json();
      })
      .then((json) => {
        if (json !== undefined) {
          //decrypt data only if needed
          if (json.isEncrypted) {
            let r2 = enc.Utf8.stringify(AES.decrypt(json.content, 'jdjdkstgggshdncbvgdjslsk'));
            json = JSON.parse(r2);
          }
        }

        if (json && json.status) {
          resolve(json);
        } else {
          let resData: TResponse = json as TResponse;
          let result = new scubeResponse(resData, true);
          resolve(result);
        }

      })
      .catch((error) => {
        console.error('[API] POST:', error);
      });
  });
}

export function restRawPostFetch<TResponse>(
  curUrl: string,
  postData: any,
  signal?: AbortSignal
): Promise<scubeResponse<TResponse>> {
  return new Promise<scubeResponse<TResponse>>((resolve, reject) => {
    const formData = new FormData();
    formData.append('data', postData);

    fetch(curUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      body: formData,
      signal: signal,
    })
      .then(async (response) => {
        const contentLength = response.headers.get('Content-Length');

        if (response.ok && contentLength == '0') {
          let result = new scubeResponse<TResponse>(undefined, true);
          resolve(result);
          return undefined;
        }

        if (!response.ok) {
          const body = await response.json();
          console.debug('[API] POST: Not Ok', body);
          reject(body);
        }
        return response.json();
      })
      .then((json) => {
        if (json && json.status) {
          resolve(json);
        } else {
          let resData: TResponse = json as TResponse;
          let result = new scubeResponse(resData, true);
          resolve(result);
        }
      })
      .catch((error) => {
        console.error('[API] POST:', error);
      });
  });
}

export function restUpdateFetch<T>(curUrl: string, postData: T, signal?: AbortSignal): Promise<scubeResponseAction> {
  return new Promise<scubeResponseAction>((resolve, reject) => {
    fetch(curUrl, {
      method: 'PUT',

      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        Authorization: 'Bearer ' + scubeContext.t2atoken,
      },
      body: JSON.stringify(postData),
      signal: signal,
    })
      .then(async (response) => {
        if (!response.ok) {
          const body = await response.json();
          //this.handleResponseError(response);
          //resolve error
          console.debug('[API] PUT: Not Ok - ', body);
          reject(body);
        }

        //console.debug("[API] PUT: Response Ok.");
        resolve(new scubeResponseAction('Ok', response.ok));
        //return;// response.json();
      })
      // 	.then(json => {
      // 	  console.debug("[API] PUT: Received some items.");

      // 	//   let resData: T = json as T;
      // 	//   let result = new scubeResponse(resData);

      // 	  console.debug("[API] PUT: Received items", result);

      // 	  //resolve(result);
      //   })
      .catch((error) => {
        console.error('[API] PUT:', error);
        //this.handleError(error);
        //resolve error
      });
  });
}

export const postFile = (url:string, modelName:string, data:any, file:Blob) => {

  const formData = new FormData();
  if (file !== null) {
    formData.append('ImageFile', file);
  } else {
    //formData.append('ImageFile', null);
  }

  for (const property in data) {
    //console.log(`${property}: ${data[property]}`);

    formData.append(`${modelName}.${property}`, data[property]);
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'if-none-match': '',
      Authorization: 'Bearer ' + scubeContext.t2atoken,
    },
    body: formData,
  });
};
